import { locItem } from '../../../model/game';

export const exterior = [
  locItem('asksvin_carrion'),
  locItem('asksvin_carrion2'),
  locItem('asksvin_carrion', 0.66, 3),
  locItem('asksvin_carrion2', 0.66, 5),
];

export const bones = [
  locItem('asksvin_carrion', 0.85, 8),
  locItem('asksvin_carrion2', 0.85, 9),
  locItem('Pickable_MeatPile', 0.5, 3),
  locItem('morgenhole_pile', 0.66, 9),
  locItem('morgenhole_pile', 1, 4),
];

export const randomwall = [
  locItem('asksvin_carrion', 0.85, 1),
  locItem('asksvin_carrion2', 0.85, 2),
  locItem('Pickable_MeatPile', 0.5, 4),
  locItem('morgenhole_pile', 0.66, 2),
  locItem('Pickable_MoltenCoreStand', 0.25),
];

export const randomwall2 = [
  locItem('asksvin_carrion', 0.85, 2),
  locItem('asksvin_carrion2', 0.85, 3),
  locItem('Pickable_MeatPile', 0.5, 4),
  locItem('morgenhole_pile', 0.66, 2),
  locItem('Pickable_MoltenCoreStand', 0.25),
];

export const randomwall3 = [
  locItem('asksvin_carrion2', 0.85),
  locItem('morgenhole_pile', 0.66),
  locItem('Pickable_MoltenCoreStand', 0.25, 2),
];

export const randomwall4 = [
  locItem('Pickable_MeatPile', 0.5, 2),
  locItem('morgenhole_pile', 0.66, 4),
  locItem('asksvin_carrion2', 0.85, 2),
  locItem('asksvin_carrion', 0.85, 1),
  locItem('Pickable_MoltenCoreStand', 0.25, 2),
];

export const chest = [
  locItem('TreasureChest_ashland_stone', 0.5, 2),
  locItem('TreasureChest_ashland_stone'),
  locItem('Pickable_MoltenCoreStand', 0.25, 8),
];

